<template>
  <div class="train-container">
    <!-- 轮播 -->
    <div class="k-banner"
         v-if="carouselpictureList.length">
      <el-carousel height="520px"
                   :interval="6000"
                   arrow="never">
        <el-carousel-item v-for="(item, index) in carouselpictureList"
                          :key="index"
                          height="520px"
                          arrow="never">
          <img :src="item.url"
               alt="培训管理轮播图"
               @click.stop="getSwiperDetail(item.id,index)" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 限时/秒杀 -->
    <!-- <div>
      <div class="header-title"
           v-if="seckillCourseList.length>0">
        <h2>限时秒杀/限时免费</h2>
        <div class="remark">Limited-time seconds kill</div>
      </div>
      <div class="seckill-train-container seckill-courseList">
        <div v-for="(item, index) in seckillCourseList"
             :key="item.id"
             class="seckill-course box-shadow"
             :class="index%4!==0? 'course-margin' :''">
          <div class="seckill-course-img"
               @click="goSeckillCourseDetail(item.id,item.activityType,item.activityStartTime,item.activityEndTime, item.sysDate)">
            <img :src="item.logoUrl || require('@/assets/img/占位图_en.png')"
                 :alt="item.name"
                 width="283px"
                 height="160px" />
          </div>
          <div class="seckill-course-name overell"
               @click="goSeckillCourseDetail(item.id,item.activityType,item.activityStartTime,item.activityEndTime, item.sysDate)">{{item.courseName}}</div>
          <div class="seckillPrice"
               v-if="item.activityType === 3">秒杀价：{{item.activitySeckillPrice}}</div>
          <div class="seckillPrice"
               v-if="item.activityType === 2">浏览量：{{item.viewCount}}</div>
          <div class="seckill-course-info">
            <div class="buyCount"
                 v-if="item.activityType === 3">购买数量{{item.salesVolumes}}</div>
            <div class="buyCount"
                 style="color:#1D65A8"
                 v-if="item.activityType === 2">限时免费</div>
            <div class="triangle"></div>
            <div class="countDown">倒计时:
              <count-down class="countDownBox"
                          v-on:end_callback="seckillEndFun"
                          :currentTime="new Date(item.sysDate).getTime()"
                          :startTime="new Date(item.activityStartTime).getTime()"
                          :endTime="new Date(item.activityEndTime).getTime()"
                          :tipText="'距离活动开始时间开始还有'"
                          :tipTextEnd="'距离订单关闭还剩'"
                          :endText="'订单已关闭'"
                          :dayTxt="'天'"
                          :hourTxt="':'"
                          :minutesTxt="':'">
              </count-down>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 为你推荐 -->
    <div style="background: #fff;padding-top: 1px;">
      <div class="header-title">
        <h2>为你推荐</h2>
        <div class="refresh"
             @click.stop="getRecommendCourseList()">换一换</div>
        <!-- <div class="remark">Recommed to you</div> -->
      </div>
      <CourserList :courseList="recommendCourseList"></CourserList>
    </div>
    <!--课程 -->
    <div style="background: #fff;padding-top:10px;">
      <h2 class="header-title">技术视频 </h2>
      <div class="doclist-typelist-first">
        <ul v-if="categoryList">
          <li v-for="(item, index) in categoryList"
              :class="{'type-active':index === choosedIndex}"
              @click="choosedCategory(index, item)"
              :key="index">{{item.videoTypeName || item.lable}}</li>
        </ul>
        <router-link class="k-doctypelist-more"
                     to="/courseList">
          <span>更多</span>
          <div class="morePicture"></div>
        </router-link>
      </div>
      <!-- 课程课表 -->
      <CourserList :courseList="courselList"
                   v-show="choosedIndex === 0"></CourserList>
      <!-- 视频列表 -->
      <TechnologyVideo :params='paramsVideo'
                       ref="technologyVideo"
                       v-show="choosedIndex !== 0"></TechnologyVideo>
    </div>
    <!--课程互动 -->
    <h2 class="header-title">工业动态 </h2>
    <div class="doclist-typelist-first">
      <ul v-if="specialList">
        <li v-for="(item, index) in specialList"
            :class="{'type-active':index === specialTabIndex}"
            @click="specialBtn(index, item)"
            :key="index">{{item.fileTypeName || item.lable}}</li>
      </ul>
      <router-link v-show="specialTabIndex !== 0"
                   class="k-doctypelist-more"
                   to="/trainbookDocList">
        <span>更多</span>
        <div class="morePicture"></div>
      </router-link>
    </div>
    <!-- 课程互动 -->
    <div v-show="specialTabIndex === 0"
         style="background: #fff;margin-top:20px;padding-top:15px;">
      <div class="comment"
           :style="'height: ' + (initCommnetLength >= 4 ? 540 : initCommnetLength*135)+ 'px' ">
        <ul class="commentul"
            :style="{transform: 'translateY(' + trnasferDistance + 'px)'}">
          <li v-for="(item, index) in commentList"
              :key="index">
            <div class="comment-img">
              <img :src="item.userAvatarURL"
                   :alt="item.userNickname"
                   width="50px"
                   height="50px" />
            </div>
            <div class="comment-detail">
              <div class="user-info">
                <div><span class="user-name">{{item.userNickname}}</span> &nbsp;评论课程：</div>
                <div>{{item.createTime}}</div>
              </div>
              <div class="course-name overell"
                   @click.stop="goCourseDetail(item.businessId)">{{item.courseName}}</div>
              <div class="comment-content overell">{{item.content}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 工业动态 -->
    <IndustryTrends v-show="specialTabIndex !== 0"
                    ref="industryTrends"
                    :params='paramsIndustry'></IndustryTrends>
    <!--名师 -->
    <div>
      <div class="header-title">
        <h2>本月之星</h2>
        <div class="more"
             @click.stop="goTeacher()">全部讲师</div>
        <!-- <div class="remark">Star of the month</div> -->
      </div>
      <TeacherList :teacherList="teacherList"></TeacherList>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils/index'
import CourserList from './common/courserList'
import TeacherList from './common/teacherList'
import CountDown from './common/countDown'
import TechnologyVideo from '@/views/modules/trainManagement/components/technologyVideo'
import IndustryTrends from '@/views/modules/trainManagement/components/industryTrends'
// 埋点
import { trainingStayTime } from '@/utils/eventTracking'
export default {
  data () {
    return {
      currentTime: new Date().getTime(),
      startTime: new Date().getTime(),
      endTime: new Date().getTime(),
      seckillCourseList: [], // 限时秒杀列表
      timer: null,
      trnasferDistance: 0,
      recommendCourseList: [], // 推荐
      courselList: [],
      carouselpictureList: [],
      commentList: [],
      teacherList: [],
      initCommnetLength: 0,
      choosedIndex: 0, // 课程默认选中
      categoryList: [ // 技术视频下label
        {
          id: null,
          lable: '课程'
        }
      ],
      paramsVideo: {}, // 向视频组件传参
      specialList: [ // 工业动态列表
        {
          id: null,
          lable: '课程互动'
        }
      ],
      specialTabIndex: 0, // 专题选中Index
      paramsIndustry: {} // 工业动态参数
    }
  },
  components: {
    CourserList,
    TeacherList,
    CountDown,
    TechnologyVideo,
    IndustryTrends
  },
  created () {
  },
  destroyed () {
    if (this.startTime) {
      let time = (new Date().getTime() - this.startTime) / 1000.0
      trainingStayTime(time)
    }
  },
  mounted () {
    this.getKnowledgeCategory()
    this.getSpecialTabList()
    this.getCarouselpictureList()

    this.getRecommendCourseList()
    this.getCourselListList()
    this.getTeacherList()
    this.getCommentList()
    this.getSeckillCourseList()
  },
  methods: {
    // 获取技术视频下的分类
    getKnowledgeCategory () {
      let list = []
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideotype/variableVideoLevel`)
        .then(({ data }) => {
          if (data.code === 0 && data.data && data.data.length) {
            list.push(...data.data)
            this.categoryList = this.categoryList.concat(list)
          }
        })
    },
    // 技术视频下的分类切换
    choosedCategory (index, val) {
      this.choosedIndex = index
      if (index === 0) {
        // 选中培训，清空选中
      } else {
        // this.routerLink = '/knowledgeVideoList'
        this.paramsVideo = val
        this.$nextTick(() => {
          this.$refs['technologyVideo'].getList()
        })
      }
    },
    // 获取工业动态
    getSpecialTabList () {
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFirstLevelFileType`
        )
        .then(({ data }) => {
          this.specialList = this.specialList.concat(data.data)
        })
    },
    // 工业动态切换 (index为0切换tab1 其他切换为tab2 其他之间互相切换时切换数据)
    specialBtn (index, val) {
      this.specialTabIndex = index
      if (index !== 0) {
        this.paramsIndustry = val
        this.paramsIndustry.index = index
        this.$nextTick(() => {
          this.$refs['industryTrends'].getSpecialList()
        })
      } else {

      }
    },
    // 倒计时结束回调
    seckillEndFun () {
      this.getSeckillCourseList()
    },
    // 获取轮播图
    getCarouselpictureList () {
      this.$http.get(`/front/user/home/homeRotationChart/selectTrainRotationChartList/true`).then(({ data: res }) => {
        this.carouselpictureList = res.data
      })
    },
    getSwiperDetail (id, index) {
      let temp = this.carouselpictureList.filter(item => {
        return item.id === id
      })
      if (temp.length) {
        if (temp[index].jump === '1' || temp[index].jump === '3') {
          openOther(decodeURIComponent(temp[index].httpAddress), true)
        } else if (temp[index].jump === '2' && temp[index].contect && temp[index].contect.length) {
          this.$router.push({ name: '5sDetail', query: { id: id } })
        }
      }
    },
    // 评论 done
    getCommentList () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.commentList = []
      this.initCommnetLength = 0
      this.$http.get(`/front/train/trainComment/listInterActAtFacePage`).then(({ data: res }) => {
        if (res.code === 0) {
          this.commentList = res.data || []
          this.initCommnetLength = this.commentList.length
        }
        if (this.commentList.length > 1) {
          let that = this
          if (this.commentList.length > 1) {
            this.timer = setInterval(function () {
              that.trnasferDistance = that.trnasferDistance + (-135)
              that.commentList.push(that.commentList[((Number(that.trnasferDistance) / -135) - 1)])
            }, 4000)
          }
        }
      })
    },
    // 推荐课程
    getRecommendCourseList () {
      this.$http.get(`/front/train/trainCourseRecommend/selectRecommendTrainCourseList`, {})
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.recommendCourseList = res.data || []
          } else {
            this.recommendCourseList = []
          }
        }).catch((e) => {
          this.recommendCourseList = []
        })
    },
    // 限时秒杀
    getSeckillCourseList () {
      this.$http.get(`front/train/trainCourse/findActivityCourseList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.seckillCourseList = res.data || []
          } else {
            this.seckillCourseList = []
          }
        }).catch((e) => {
          this.seckillCourseList = []
        })
    },
    // 课程 done
    getCourselListList () {
      this.$http.post(`/front/train/trainCourse/select8BoutiqueTrainCourseList`, {})
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.courselList = res.data || 0
          } else {
            this.courselList = []
          }
        }).catch((e) => {
          this.courselList = []
        })
    },
    // 讲师列表
    getTeacherList () {
      this.teacherList = []
      this.$http.post(`/front/train/trainTeacher/getTeacher`, {
        count: 8
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.teacherList = res.data
        }
      })
        .catch((e) => { })
    },
    goCourse () {
      this.$router.push({ name: 'courseList' })
    },
    goCourseDetail (id) {
      this.$router.push({ name: 'courseDetail', query: { id: id } })
    },
    goSeckillCourseDetail (id, activityType, activityStartTime, activityEndTime, sysDate) {
      var seckillStartTime = new Date(activityStartTime).getTime()
      var seckillEndTime = new Date(activityEndTime).getTime()
      var seckillCurrentTime = new Date(sysDate).getTime()
      this.$router.push({ name: 'courseDetail', query: { id: id, activityType: activityType, activityStartTime: seckillStartTime, activityEndTime: seckillEndTime, currentTime: seckillCurrentTime } })
    },
    goTeacher () {
      this.$router.push({ name: 'teacherList' })
    }
  }
}
</script>

<style scoped lang='scss'>
.doclist-typelist-first {
  line-height: 20px;
  font-size: 14px;
  color: #333333;
  width: 1190px;
  margin: 0 auto 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.doclist-typelist-first {
  display: flex;
}
.doclist-typelist-first div {
  margin-right: 20px;
}
.doclist-typelist-first ul {
  /* width: 810px; */
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  color: #333333;
}
.doclist-typelist-first ul li {
  margin-right: 20px;
  line-height: 40px;
  user-select: none;
  cursor: pointer;
}
.doclist-typelist-first ul :hover {
  color: #1d65a8;
}
.type-active {
  color: #1d65a8;
}
.type-active :hover {
  background: #1d65a8;
  color: #fff;
}
/* 培训整体 */
.train-container {
  min-width: 1190px;
  /* padding: 0 20px; */
  margin: 0 auto;
}
/* 顶部轮播图 */
.k-banner {
  margin: 0 auto 30px;
  width: 1190px;
  height: 520px;
  /* margin-bottom: 30px; */
}
.el-carousel__arrow {
  display: none;
}
.el-carousel {
  height: 520px;
}
.el-carousel__container {
  height: 520px;
}
.el-carousel__item {
  height: 520px;
}
.el-carousel__item img {
  cursor: pointer;
  height: 520px;
  width: 100%;
  /* width: 1190px; */
  display: block;
}
/* 为你推荐 */
.header-title {
  margin: 32px auto 10px;
  width: 1190px;
  text-align: left;
  position: relative;
}
.header-title h2 {
  font-size: 28px;
  line-height: 40px;
  font-weight: normal;
}
.header-title .more {
  position: absolute;
  top: 0;
  right: 0;
  padding-right: 20px;
  line-height: 40px;
  font-size: 14px;
  color: #333333;
  text-align: right;
  cursor: pointer;
  background: url("~@/assets/img/gomoreto.png") no-repeat center right;
  background-size: 14px 14px;
}
.header-title .refresh {
  position: absolute;
  top: 0;
  right: 0;
  padding-right: 20px;
  line-height: 40px;
  font-size: 14px;
  color: #333333;
  text-align: right;
  cursor: pointer;
  background: url("~@/assets/img/refresh.png") no-repeat center right;
  background-size: 12px 12px;
}
.header-title .remark {
  margin-top: 8px auto 30px;
  font-size: 16px;
  color: #999999;
  text-align: center;
}
.recommend-header {
  margin: 32px 0 30px;
  line-height: 30px;
  display: flex;
  /* justify-content: space-between; */
  justify-content: center;
}
.recommend-header h2 {
  font-size: 28px;
  line-height: 40px;
  font-weight: normal;
}
.recommend-header .refresh {
  color: #1d65a8;
  user-select: none;
  cursor: pointer;
}
/* 课程互动 */
.comment {
  width: 1190px;
  margin: 10px auto;
  /* height: 540px; */
  overflow: hidden;
}
.commentul {
  transition: 0.5s ease-in-out;
}
.comment ul li {
  /* display: flex; */
  padding: 5px 10px;
  padding-top: 30px;
  height: 135px;
  border-bottom: 1px solid #eee;
}
.comment-img {
  /* display: inline-block; */
  width: 62px;
  height: 52px;
  border-radius: 31px;
  overflow: hidden;
  float: left;
}
.comment-detail {
  /* display: inline-block; */
  margin-left: 75px;
}
.course-name {
  margin-top: 10px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #1d65a8;
  cursor: pointer;
}
.comment-content {
  margin-top: 10px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666666;
}
.user-info {
  display: flex;
  justify-content: space-between;
}
.user-name {
  color: #000;
  font-size: 16px;
}
/* 限时秒杀样式 */
.seckill-train-container {
  width: 1190px;
  /* padding: 0 20px; */
  margin: 0 auto;
}
.seckill-courseList {
  /* border: 1px solid #000; */
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  align-content: flex-start;
}
.seckill-course {
  width: 283px;
  /* height: 149px; */
  /* border: 1px solid #000; */
  margin: 0 0 50px 0;
  overflow: hidden;
  background: #fff;
}
.course-margin {
  margin-left: 19px;
}
.seckill-course-img {
  cursor: pointer;
  width: 283px;
  height: 160px;
}
.seckill-course-name {
  margin-top: 10px;
  padding-left: 12px;
  /* height: 22px; */
  line-height: 22px;
  font-size: 16px;
  color: #262626;
  cursor: pointer;
  user-select: none;
}
.seckill-course-name:hover {
  color: #1d65a8;
}
.seckill-course-info {
  line-height: 20px;
  font-size: 14px;
  color: #999;
  display: flex;
  justify-content: space-between;
}
.buyCount {
  display: inline-block;
  width: 40%;
  height: 40px;
  line-height: 40px;
  padding-left: 12px;
}
.countDown {
  width: 60%;
  height: 40px;
  line-height: 40px;
  background: #1d65a8;
  color: white;
}
.seckillPrice {
  padding-left: 12px;
  height: 30px;
  line-height: 30px;
}
.triangle {
  width: 0px;
  height: 0px;
  border-top: 40px solid transparent;
  border-right: 40px solid #1d65a8;
}
.countDownBox p {
  color: white !important;
}
.k-doctypelist-more {
  padding-left: 8px;
  padding-right: 5px;
  font-size: 14px;
  color: #262626;
  display: flex;
  line-height: 32px;
  user-select: none;
  cursor: pointer;
}
.k-doctypelist-more:hover span {
  color: #ffffff;
}
.morePicture {
  width: 10px;
  height: 11px;
  display: block;
  margin-right: 0 !important;
  margin-top: 10px;
  margin-left: 6px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover {
  background: #1d65a8;
  color: white;
}
.k-doctypelist-more:hover .morePicture {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTNGRUVFQjFDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTNGRUVFQjJDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBM0ZFRUVBRkM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBM0ZFRUVCMEM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Puq9PDkAAABxSURBVHjalJNJDsAwCAPB//8zbaUeXArBcMgmD4FE9oiwO57BTQi8YqN5BDhzKIBtINBagpD2I4Ti7AihubmFcOivhDC84g+C8FcfSAG4B8dGPJUUVVnYiDugFVfAUZyBUcyAJM6OM8Wm7DjJ05cAAwA/gRgnP8oHOgAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover .moreLink {
  color: white !important;
}
</style>
